import AlchemyModal, { ModalBody, ModalFooter, ModalHeader, ModalProps } from 'UIKit/AlchemyModal'
import Flex from 'UIKit/Box/Flex'
import { DepositFreespinBonus, FreespinBonus } from 'config/types/bonus/userBonus'
import { useCountDown } from 'hooks/useCountdown'
import React, { useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { ModalColorTheme } from 'theme/modal/colors'
import BonusAction from 'views/BonusCenter/components/BonusAction'
import { displayCountdownTimeUnit } from 'views/Cashback/utils'

import Box from 'UIKit/Box/Box'

import Image from 'UIKit/Image/Image'

import Text from 'UIKit/Text/Text'
import { ColumnCenter } from 'layout/Components/Column'
import { useUserBonus } from 'state/bonus/hooks/useUserBonus'
import FreespinBonusBody from './FreespinBonusBody'

interface FreespinBonusModalProps {
  onSubmitted: () => void
  bonusId: number
  isZeroAmount?: boolean
}

export const InfoSection = ({ isZeroAmount }: { isZeroAmount?: boolean }) => {
  return (
    <Flex flexDirection="column" alignItems="center" overflow="hidden">
      <Box width="130px" height="120px">
        <Image src="/images/bonusCenter/gift-header-title.png" width={300} height={300} />
      </Box>
      <Text mt="20px" fontWeight="700" fontSize="20px">
        {isZeroAmount ? <Trans>A Twist of Fate!</Trans> : <Trans>You got a Bonus</Trans>}
      </Text>
      <Text
        fontSize="14px"
        fontWeight="400"
        color="textSubtle"
        mt="8px"
        textAlign="center"
        maxWidth="320px"
        marginX="auto"
        lineHeight="17.07px"
      >
        {isZeroAmount ? (
          <Trans>
            Turn that ZERO into a HERO! Despite the unlucky spin result. we will give you a special prize with the
            maximum reward of this bonus!
          </Trans>
        ) : (
          <Trans>Congrats! You have used all Free Spins and recieve a bonus</Trans>
        )}
      </Text>
    </Flex>
  )
}

const FreespinBonusModal: React.FC<ModalProps<FreespinBonusModalProps>> = ({
  onDismiss,
  data: { bonusId, onSubmitted, isZeroAmount },
}) => {
  const { bonuses } = useUserBonus()
  const bonus = useMemo(() => bonuses.find((b) => b.id === bonusId), [bonuses, bonusId])

  const { t } = useTranslation()

  const bonusExpireTimeRef = useCountDown(
    bonus.condition.expiryDate || 0,
    (s, m, h, d) => `
      ${displayCountdownTimeUnit(t('day'), 'Day', d)}
      <div class='colon-mark'>:</div>
      ${displayCountdownTimeUnit(t('hour'), 'Hour', h)}
      <div class='colon-mark'>:</div>
      ${displayCountdownTimeUnit(t('min'), 'Min', m)}
      <div class='colon-mark'>:</div>
      ${displayCountdownTimeUnit(t('sec'), 'Sec', s)}
    `,
    () => {},
  )

  const handleSubmit = () => {
    onSubmitted()
    onDismiss()
  }

  return (
    <>
      {(bonus instanceof DepositFreespinBonus || bonus instanceof FreespinBonus) && (
        <>
          <StyledModal colorTheme={ModalColorTheme.Darkblue} onDismiss={onDismiss}>
            <ModalHeader colorTheme={ModalColorTheme.Darkblue} />

            <ModalBody>
              <InfoSection isZeroAmount={isZeroAmount} />
              <FreespinBonusBody mt="20px" px="12px" bonus={bonus} />
            </ModalBody>

            <ModalFooter>
              <ColumnCenter>
                <StyledButtonAction
                  trackingModule="finishFreeSpinModal"
                  bonus={bonus}
                  onBonusSubmitted={handleSubmit}
                />
                <StyledCountdownContent ref={bonusExpireTimeRef} />
              </ColumnCenter>
            </ModalFooter>
          </StyledModal>
        </>
      )}
    </>
  )
}
const StyledModal = styled(AlchemyModal)`
  ${({ theme }) => theme.mediaQueries.sm} {
    min-width: 360px !important;
    max-width: 360px !important;
  }
`

const StyledButtonAction = styled(BonusAction)`
  max-width: 290px;
  margin-inline: auto;
  width: 100%;
  border-radius: 8px;
  font-weight: bold;
  font-size: 14px;
`

const StyledCountdownContent = styled(Flex)`
  color: ${({ theme: { colors } }) => colors.textAlt1};
  font-size: 12px;
  margin-top: 12px;
  margin-inline: auto;

  div {
    width: 20px;
    text-align: center;
  }

  span {
    color: ${({ theme: { colors } }) => colors.textAlt1};
    width: 12px;
    text-align: center;
  }

  .day,
  .hour,
  .min,
  .sec {
    .value {
      color: ${({ theme: { colors } }) => colors.text};
      font-weight: bold;
      margin-bottom: 1px;
    }
  }
`

export default FreespinBonusModal
